import { Input, Select } from 'antd';
import { FormItemProps } from 'antd/lib';
import { CRX_SUPPORT_EMAIL } from 'app/config';
import { ComponentType } from 'react';
import { OPTIONS_PROVINCES_OR_STATES } from '../../../../lib/documents/clinic';

export interface FormQuestion {
  id?: string;
  component: React.ReactElement | ComponentType;
  rules?: FormItemProps['rules'];
  required?: FormItemProps['required'];
  /**
   * The label the form should use
   */
  label?: string;
  name: string | string[];
  tooltip?: string;
}

const questions: FormQuestion[] = [
  {
    name: 'name',
    label: 'Organization Name',
    component: <Input placeholder="Organization Name" />
  },
  {
    name: 'country',
    label: 'Country',
    tooltip: 'Contact ConcussionRx support if this field needs to be changed',
    component: (
      <Select
        showSearch
        placeholder="Country"
        disabled
        options={[
          {
            label: 'Canada',
            value: 'CA'
          },
          {
            label: 'United States of America',
            value: 'US'
          }
        ]}
      />
    ),
    rules: [
      {
        type: 'enum',
        required: true,
        enum: ['CA', 'US'],
        message: `Please select a country. If your country is not listed please email ${CRX_SUPPORT_EMAIL}`
      }
    ]
  },
  {
    name: 'provinceOrState',
    label: 'Province or State',
    component: (
      <Select
        showSearch
        placeholder="Province/State"
        options={OPTIONS_PROVINCES_OR_STATES}
      />
    ),
    rules: [
      {
        type: 'enum',
        required: true,
        enum: OPTIONS_PROVINCES_OR_STATES.map(_ => _.value),
        message: `Please select your province or state. If your location is not listed please email ${CRX_SUPPORT_EMAIL}`
      }
    ]
  },
  {
    name: 'city',
    label: 'City',
    component: <Input placeholder="City" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: `Please enter your city`
      }
    ]
  },
  {
    name: 'address',
    label: 'Address',
    component: <Input placeholder="Address" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: "Please enter the remainder of your organisation's address"
      }
    ]
  },
  // {
  //   name: 'addressLine2',
  //   label: 'Address Line 2',
  //   component: <Input placeholder="Organization Address Line 2" />
  // },
  {
    name: 'postalOrZipCode',
    label: 'Postal or Zip code',
    component: <Input placeholder={'Postal/Zip Code'} />,
    rules: [
      {
        type: 'string',
        required: true,
        message: `Please enter your organisation's postal code`
      },
      {
        pattern:
          /(^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$)|(^\d{5}(?:[-\s]\d{4})?$)/i,
        message: 'The postal or zip code is invalid. Examples: A1A1A1 or 12345'
      },
      {
        transform: (val: string) => val.toUpperCase().replace(/[ -]/, '')
      }
    ]
  },
  {
    name: 'phoneNumber',
    label: 'Phone number',
    component: <Input placeholder="Phone Number" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: `Please enter your organisation's phone number`
      }
    ]
  },
  {
    name: 'faxNumber',
    label: 'Fax number',
    component: <Input placeholder="Fax Number" />,
    rules: [
      {
        type: 'string',
        message: `Please enter your organisation's fax number if you have one`
      }
    ]
  }
];

export const QUESTIONS_CLINIC_EDIT = questions.filter(
  q =>
    !Array.isArray(q.name) ||
    (Array.isArray(q.name) && q.name[0] !== 'paymentConfig')
);
